import { bl_fi_generic_doc_hdr_RowClass } from '../../dbschema';
import { bl_fi_deposit_register_hdr_gendoc_link_RowClass } from '../../dbschema/bl_fi_deposit_register_hdr_gendoc_link.model';
import { BaseContainerModel } from '../base-container.model';

export class DepositRegisterGenDocLinkContainerModel extends BaseContainerModel {
  bl_fi_deposit_register_hdr_gendoc_link: bl_fi_deposit_register_hdr_gendoc_link_RowClass = new bl_fi_deposit_register_hdr_gendoc_link_RowClass();
  bl_fi_generic_doc_hdr: bl_fi_generic_doc_hdr_RowClass = new bl_fi_generic_doc_hdr_RowClass();
}
